module.exports = __webpack_public_path__ + "static/2-be86ff8340b70c92bd00e7881909a417.png";